/**
 * Expandable component to display more content
 **/

import React from "react"
import parse from "html-react-parser"
import { kebabCase } from "lodash"
import { Transition } from "@headlessui/react"
import { useState } from "react"
import Modal from "./modal"
import {  HiChevronRight, HiPlus } from "react-icons/hi"

const Expandable = ({ props, headingLevel, annualReport }) => {
  const format = props?.format
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      {format === "modal" && props?.expandedContent ?
        <div>
          <div>
            {props.expandedContent ? (
              <Modal
                modalContent={props.expandedContent}
                heading={props.heading}
                buttonClass="block w-full"
                button={
                  <div className={`flex items-stretch justify-between group transition-all ${annualReport === "2024"? "hover:bg-gray-200/70 border border-ar24-blue-900 rounded-lg p-4" : "hover:scale-101"} ${annualReport === "2023" ? "-my-4 py-4 -mx-2 px-2 hover:bg-white hover:outline-1 hover:outline outline-gray-300" : ""}`}>
                    <div className={`text-left flex flex-col justify-between`}>
                      {props.heading && (
                        ExpandableHeader(headingLevel, props, annualReport)
                      )}
                      {props.content ? (
                        <div className={`print:hidden parsed-content`}>
                          {parse(props.content)}
                        </div>
                      ) : null}
                    </div>
                    <div className={`flex items-center ml-4 print:hidden flex-shrink-0 justify-center ${annualReport === "2024" ? "w-8 h-8 border border-ar24-blue-900 my-auto rounded-full group-hover:bg-ar24-blue-900 group-hover:text-white transition" : annualReport === "2023" ? "group-hover:animate-glide" : "rounded group-hover:bg-gray-900/5"}`}>
                      {annualReport === "2024" ? (
                        <HiPlus className={`transform group-hover:scale-105 hover:scale-105 transition-all `} />
                      ) :
                        <HiChevronRight className={`text-2xl transform group-hover:scale-105 hover:scale-105 transition-all`} />
                      }
                    </div>
                  </div>
                }
              ></Modal>
            ) : null}

          </div>
        </div>
        : props.expandedContent ? (
          <>
            <div className="print:my-4 relative">
              <button
                onClick={() => setIsOpen(!isOpen)}
                aria-controls={`${kebabCase(props.heading)}-expanded`}
                aria-expanded={isOpen}
                className={`flex flex-row relative items-stretch text-left group ${annualReport === "2024"? "hover:bg-gray-200/70 border border-ar24-blue-900 rounded-lg p-4" : "hover:scale-101"} transition-all  ${annualReport ? "outline-transparent outline-1" : ""} ${!isOpen ? `${annualReport === "2023" ? "-my-4 py-4 px-2 -mx-2 w-[calc(100%_+_1rem)] hover:bg-white hover:outline hover:outline-gray-300" : "w-full "}` : " w-full"}`}>
                {/* <!-- Expand/collapse button --> */}
                <div
                  className={`grow print:block  ${!isOpen ? `flex items-center` : ""
                    }`}
                >
                  <div className={`flex flex-col justify-between ${isOpen ? "" : "w-full"}`}>
                    {props.heading && (
                      ExpandableHeader(headingLevel, props, annualReport)
                    )}
                    {props.content ? (
                      <>
                        <Transition show={!isOpen}>
                          <div
                            className={`print:hidden parsed-content`}
                          >
                            {parse(props.content)}
                          </div>
                        </Transition>
                      </>
                    ) : null}
                  </div>
                  <Transition show={isOpen}>
                    <div
                      id={`${kebabCase(props.heading).replace(
                        /[0-9]/g,
                        ""
                      )}-expanded`}
                      className={`parsed-content print:hidden`}
                    >
                      {parse(props.expandedContent)}
                    </div>
                  </Transition>
                  <div className="print:block hidden pb-6 parsed-content">
                    {parse(props.expandedContent)}
                  </div>
                </div>
                <div
                  className={`flex items-center ml-4 print:hidden text-left flex-shrink-0 justify-center ${annualReport === "2024" ? "w-8 h-8 border border-ar24-blue-900 my-auto rounded-full group-hover:bg-ar24-blue-900 group-hover:text-white transition" : annualReport === "2023" ? "group-hover:animate-glide-down" : "rounded group-hover:bg-gray-900/5 hover:bg-gray-900/5"}`}
                  aria-hidden="true"
                >

                  <HiChevronRight className={`${isOpen ? "-rotate-90" : "rotate-90"} text-xl transform group-hover:scale-105 hover:scale-105 transition-all`} />

                  {/* 
                  <svg
                    
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg> */}
                </div>
              </button>
            </div>
          </>
        ) : (
          <div className="">
            <div className={`text-left w-full flex justify-between items-start ${annualReport === "2024" ? "border border-ar24-blue-900 rounded-lg p-4" : ""}`}>
              <div>
                {props.heading && (
                  ExpandableHeader(headingLevel, props, annualReport)
                )}
                {props.content ? (
                  <div
                    className="parsed-content"
                  >
                    {parse(props.content)}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
    </>
  )
}

// setting default value to name prop
Expandable.defaultProps = {
  headingLevel: "h3",
}

export default Expandable
function ExpandableHeader(headingLevel, props, annualReport) {
  return <div
    className={`group-copy-link ml-0 pl-0 group grid grid-cols-1 justify-start`}
  >
    {headingLevel === "h3" ? (
      <h3 className="mb-2 leading-snug" id={kebabCase(props.heading).replace(/[0-9]/g, "")}>
        {props.heading}
      </h3>
    ) : (
      <h4 className={`mb-1 leading-snug ${annualReport === "2024" ? "font-black text-lg" : "text-base font-sans font-medium"}`} id={kebabCase(props.heading).replace(/[0-9]/g, "")}>
        {props.heading}
      </h4>
    )}
    {/* <CopyLinkButton
      heading={props.heading}
      className="-left-2 top-0" /> */}
  </div>
}

